import { render, staticRenderFns } from "./MarketRatesCards.vue?vue&type=template&id=45cd6002"
import script from "./MarketRatesCards.vue?vue&type=script&lang=js"
export * from "./MarketRatesCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports